import React from 'react';
import styled from 'styled-components';

import { Body2 } from 'components/atoms/Text';

const InputDiv = styled.div`
    width: 100%;
    min-width: 250px;
    height: fit-content;
    padding-top: 12px;
    padding-bottom: 12px;
`;

const InputOuterContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;

    &:focus-within {
        color: #6347ff;
        & p {
            color: #6347ff;
        }
    }
`;

const StyledBody2 = styled(Body2)`
    margin-bottom: 8px;
`;

const AccountInput = styled.input`
    border: ${(props) => (props.showMenu ? '1px solid #4136c0' : '1px solid rgba(0, 0, 0, 0.24)')};
    border-radius: 6px;
    width: 100%;
    height: 40px;
    font-size: 14px;
    padding-left: 15px;
    padding-right: 15px;

    &:disabled {
        background-color: white;
    }

    &:focus {
        outline: none;
        border: 1px solid #4136c0;
    }

    &:hover {
        outline: none;
        border: 1px solid #4136c0;
    }
`;

const WarningMessage = styled.p`
    display: ${(props) => (props.visible ? 'block' : 'none')};
    color: #db5019;
    margin-top: 10px;
`;

const InputWithBorder = ({
    id,
    className,
    error,
    errorMessage = '',
    placeholder = '',
    required = false,
    title = '',
    value = '',
    onChange: handleChange,
    ...props
}) => {
    return (
        <InputDiv id={id} className={className}>
            <InputOuterContainer>
                <StyledBody2>
                    {title}
                    {required && ' *'}
                </StyledBody2>
                <AccountInput
                    placeholder={placeholder}
                    type={'text'}
                    value={value}
                    onChange={(e) => handleChange(e.target.value)}
                    {...props}
                />
                <WarningMessage visible={error}>• {errorMessage}</WarningMessage>
            </InputOuterContainer>
        </InputDiv>
    );
};

export default InputWithBorder;
